import { Component, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { AuthService } from "../../share/service/auth.service";
import { AlertService } from "src/app/share/service/alert.service";
import { TranslateService } from "@ngx-translate/core";
import { LoadingService } from "src/app/share/service/loading.service";
import { UserDataService } from "src/app/share/data-service/user.data.service";
import { Router } from "@angular/router";
import { PartnerService } from "src/app/share/service/partner.service";

@Component({
	selector: "app-forgot-password",
	templateUrl: "./forgot-password.component.html",
	styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
	success: boolean;
	formGroup: UntypedFormGroup;
	partnerCode: string = "ps";
	bannerLink: string = "https://storage.googleapis.com/ps-asset/digi_rep/hero/dr-bg.png";
	routerLink: string = "/login";

	constructor(
		authService: AuthService,
		public alertService: AlertService,
		private router: Router,
		public translate: TranslateService,
		public userDataService: UserDataService,
		private loadingService: LoadingService,
		private partnerService: PartnerService
	) {
		this.partnerCode = this.partnerService.getPartnerCode();

		if(!this.partnerCode) {
			this.partnerCode = "ps";
		} 
		this.getPartnerInfo(this.partnerCode);

		if (this.partnerCode?.length) {
			localStorage.removeItem("partner");
		}

		if (authService.isLoggedIn()) {
			location.href = "/transactions";
		}
	}

	ngOnInit(): void {
		this.formGroup = new UntypedFormGroup({
			email: new UntypedFormControl(null, [Validators.email, Validators.required]),
		});
	}

	reset() {
		if (this.formGroup.invalid) return;
		this.loadingService.loadingOn(true);
		let objRequest = {
			email: this.formGroup.get("email")?.value,
		};

		this.userDataService
			.sendForgotPasswordEmail(objRequest, this.partnerCode)
			.subscribe({
				next: (x) => {
					this.loadingService.loadingOff(true);
					this.success = true;
				},
				error: (err) => {
					this.loadingService.loadingOff(true);
					this.success = false;
					this.alertService.openSnackBar("Email not found");
				},
			});
	}

	private getPartnerInfo(partnerCode) {
		if(partnerCode && partnerCode != 'ps'){
			this.bannerLink = `https://storage.googleapis.com/ps-asset/digi_rep/hero/dr_${partnerCode}-bg.png`
			this.routerLink = `/login?partnerCode=${partnerCode}`;
		}
	}

	goToLogin() {
		if(this.partnerCode && this.partnerCode != 'ps' ) {
			window.location.href = "/login?partnerCode=" + this.partnerCode;
		} else {
				window.location.href = "/login";
		}
	}
}
